import {
  type ForwardedRef,
  forwardRef,
  type TextareaHTMLAttributes,
  useContext,
} from "react";
import { twMerge } from "tailwind-merge";
import { InputContext } from "./InputContext";
import { generatePlaceholder } from "./utils/generatePlaceholder";

type InputTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  variant?: "default" | "legacyFixed";
};

export const InputTextArea = forwardRef(
  (
    { variant = "default", ...props }: InputTextAreaProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const { inputId } = useContext(InputContext);

    return (
      <textarea
        ref={ref}
        id={inputId}
        {...props}
        className={twMerge(
          "w-full appearance-none bg-transparent text-zinc-900 !caret-zinc-900 outline-hidden outline-0 placeholder:text-zinc-400 disabled:cursor-not-allowed disabled:text-zinc-400 dark:text-zinc-100 dark:!caret-zinc-100 dark:placeholder:text-zinc-500 dark:disabled:text-zinc-500",
          variant === "legacyFixed" && "h-[200px] resize-none",
          props.className,
        )}
        placeholder={generatePlaceholder(props.placeholder)}
      />
    );
  },
);

InputTextArea.displayName = "InputTextArea";
